import { Component, OnInit } from '@angular/core';
import { AppSettings } from '../app.settings';
import { Store, Select } from '@ngxs/store';
import {
  BillingInfo,
  BillingInfoActions
} from '../transaction-store/billing-info';
import { Observable } from 'rxjs';
import { Donation, DonationType } from '../transaction-store/donation';

@Component({
  selector: 'app-billing-info',
  template: `
    <section class="container" *ngIf="displayBillingFields">
      <div class="box-group company-individual" *ngIf="company">
        <label
          [ngClass]="
            displayCompanyField ? 'btn-outline-secondary' : 'btn-primary'
          "
          tabindex="0"
          (click)="displayCompanyField = false"
          (keypress)="toggleCompanyField($event, false)"
          aria-label="Individual"
          class="col"
        >
          Individual
        </label>
        <label
          [ngClass]="
            !displayCompanyField ? 'btn-outline-secondary' : 'btn-primary'
          "
          tabindex="0"
          (click)="displayCompanyField = true"
          (keypress)="toggleCompanyField($event, true)"
          aria-label="Company"
          class="col btn-outline-secondary"
        >
          Company
        </label>
      </div>
      <div>
        <h2 class="section-title">Billing Info</h2>
      </div>
      <div>
        <address-block
          (blur)="onBlur($event)"
          [addressSource]="billingInfo$ | async"
          [international]="international"
          [showCompany]="displayCompanyField"
          [showMiddle]="middle"
          [showTitle]="title"
          [requireTitle]="title_required"
          [requirePhone]="phone_required"
          [requireEmail]="true"
          [titles]="title_lookup"
        ></address-block>
      </div>
    </section>
  `
})
export class BillingInfoComponent {
  @Select() donation$: Observable<Donation>;
  @Select() billingInfo$: Observable<BillingInfo>;

  international = false;
  // show company options [individual / company]
  company = false;
  middle = false;
  displayCompanyField = false;
  title = false;
  title_required = false;
  phone_required = false;
  title_lookup = [];
  infoType = 'credit';
  displayBillingFields = true;
  constructor(private settings: AppSettings, private store: Store) {
    this.international = this.settings.getValue(
      'properties'
    ).accept_international_donations;
    this.company = this.settings.getValue('properties').show_company_name;
    this.middle = this.settings.getValue('properties').enable_middle_name;
    this.title = this.settings.getValue('properties').enable_title;
    this.title_required = this.settings.getValue('properties').require_title;
    this.phone_required = this.settings.getValue('properties').require_phone;
    this.title_lookup = this.settings.getValue('properties').title_lookup;
    this.donation$.subscribe(donation => {
      this.infoType = donation.type;
      // hide the billing fields for Apple Pay, Google Pay
      this.displayBillingFields = (this.infoType !== DonationType.ApplePay) && (this.infoType !== DonationType.GooglePay);
    });
  }

  onBlur($event) {
    this.store.dispatch(
      new BillingInfoActions.AddBillingInfo({
        key: $event.name,
        value: $event.value
      })
    );
  }

  toggleCompanyField($event, value) {
    $event.preventDefault();
    $event.stopPropagation();
    if ($event.keyCode === 13 || $event.keyCode === 32) {
      return this.displayCompanyField = value;
    }
  }
}
